/**
 * testObject
 *
 * Module that builds an object based on the 'Tests' parameter in the query string.
 * It sets each parameter to true.
 *
 * @return {object}
 */

OT.createNS('OT.Common.TestObject');

OT.Common.TestObject = (function() {
    'use strict';

    var $body     = $('body'),
        testArray = [];

    var refresh = function() {
        var params = OT.Common.Helpers.QueryString.parse();

        if(!params.tests) {
            testArray = [];
        } else {
            if(typeof params.tests === 'string') {
                params.tests = [params.tests];
            }
            testArray = _.map(params.tests, function(val) {
                return val.toLowerCase();
            });
        }
    };

    var buildTestArray = function(fresh) {
        if(fresh) {
            refresh();
        }

        // Add the test names to the body
        $body.addClass(testArray.join(' '));

        return testArray;
    };

    var isActive = function(tests) {
        if(!tests) {
            return false;
        }

        var allTestsAreOn = true;

        if(typeof tests === 'string') {
            tests = [tests];
        }

        _.each(tests, function(test) {
            if(testArray.indexOf(test.toLowerCase()) === -1) {
                allTestsAreOn = false;
            }
        });

        return allTestsAreOn;
    };

    var set = function(key, val) {
        if(_.isNull(key) || _.isNull(val)) {
            throw new Error('testArray: No parameters provided');
        }

        testArray.push(key.toLowerCase());

        OT.Events.fire('testObject:updated', testArray);
    };

    refresh();
    buildTestArray();

    return {
        set: set,
        getAll: buildTestArray,
        refresh: refresh,
        isActive: isActive
    };

})();
